export default __webpack_public_path__ + "static/media/whiteDownArrow.a6938db0.svg";